import { ClickEvent, DataDisplayEvent, DataSourceAction, DataSourceExecutionEvent, Label } from "@mcleod/components";
import { AutogenLayoutDispatchPrev } from "./autogen/AutogenLayoutDispatchPrev";
import { StopList } from "../StopList";
import { StopProgress } from "../StopProgress";
import { PlanningUtil } from "../planning/PlanningUtil";
import { TrailerUtil } from "../TrailerUtil";

export class DispatchPrev extends AutogenLayoutDispatchPrev {

    onLoad(): void | Promise<void> {
        this.labelOrderId.addUnderlineWhenMouseOver();
        TrailerUtil.setupMaxTrailers(this.textboxTrailerId, this.panelTrailer2, this.panelTrailer3);
    }

    sourceMovementAfterExecution(event: DataSourceExecutionEvent) {
        if (event.getAction() == DataSourceAction.SEARCH) {
            this.sourceEquipmentGroup.search({ id: this.activeRow.get("equipment_group_id") });
            (this.layoutStopProgress as StopProgress).setStopsTable((this.layoutStopList as StopList).tableStop);
        }
    }

    sourceStopAfterExecution(event: DataSourceExecutionEvent) {
        const destination = this.sourceStop.data.at(-1);
        this.textboxDriverLoadUnload.text = destination.getLookupModelData("driver_load_unload")[0].get("descr");
    }

    orderNumberOnClick(event: ClickEvent) {
        PlanningUtil.navigateToOrder(event);
    }

    labelOrderWeightOnDataDisplay(event: DataDisplayEvent) {
        const labelWeight = event.target as Label;
        const row = event.rowData;
        if (row && !row.isNull("orders.weight")) {
            labelWeight.text = `${row.get("orders.weight")} ${row.get("orders.weight_um")}`;
        }
    }

    sourceEquipmentGroupAfterExecution(event: DataSourceExecutionEvent) {
        if (event.getAction() == DataSourceAction.SEARCH) {
            const equipmentGroupSummary = this.sourceEquipmentGroup.summaryData;
            if (equipmentGroupSummary) {
                this.activeRow.setValues(equipmentGroupSummary.data);
            }
        }
    }

}
